var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"area","height":"375","options":_vm.chartOptions,"series":_vm.series}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }